The human readable name of the competency.
